import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {Link} from 'react-router-dom';
import {useLocale} from '../context/LocaleContext';

// Handles the Google OAuth return: reads session_id from URL fragment, exchanges it,
// then returns the authenticated user to the Sanal Dergâh member area.
export default function AuthCallback() {
  const {t} = useLocale();
  const location = useLocation();
  const navigate = useNavigate();
  const { processGoogleSession } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/giris", { replace: true });
      return;
    }

    (async () => {
      try {
        await processGoogleSession(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/sanal-dergah", { replace: true });
      } catch (e) {
        window.history.replaceState(null, "", window.location.pathname);
        setError(e.response?.status===409 ? "Mevcut giriş yönteminizi kullanın; hesaplar otomatik birleştirilmez." : "Oturum doğrulanamadı. Lütfen tekrar deneyin.");
      }
    })();
  }, [location.hash, navigate, processGoogleSession]);

  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-5"
      style={{ background: "var(--sy-bg)" }}
    >
      <img src="/sayyadi-logo-dark.png" alt="Sayyâdî" className="w-52 select-none" draggable={false} />
      {error ? (
        <><p role="alert" style={{ color: "#e4706e" }}>{t(error)}</p><Link to="/giris" className="underline min-h-[44px] px-4 py-3">{t('Giriş Yap')}</Link></>
      ) : (
        <>
          <div
            className="h-8 w-8 rounded-full border-2 sy-ring-pulse"
            style={{ borderColor: "var(--sy-gold)", borderTopColor: "transparent" }}
          />
          <p style={{ color: "var(--sy-text-dim)" }}>Oturum açılıyor…</p>
        </>
      )}
    </div>
  );
}
